import { Phone } from 'lucide-react'

/**
 * Hot-lead marker shown when a tenant has requested a founder callback
 * (`founderCallbackRequested === true`). This is a signal staff must not miss,
 * so it uses a high-contrast warm treatment rather than a muted pill.
 *
 * - `size="lg"` (detail header): a prominent, fully-labelled badge.
 * - `size="sm"` (list row): a compact chip that sits beside the company name.
 */
export function FounderCallbackBadge({ size = 'lg' }: { size?: 'lg' | 'sm' }) {
  const base =
    'inline-flex items-center gap-1.5 rounded-sm bg-[#3d2e00] font-label font-semibold uppercase tracking-wider text-[#ffd080]'
  const sizing = size === 'lg' ? 'px-2.5 py-1 text-xs' : 'px-1.5 py-0.5 text-[0.6rem]'
  const icon = size === 'lg' ? 'h-3.5 w-3.5' : 'h-3 w-3'

  return (
    <span className={`${base} ${sizing}`} title="This customer has requested a callback">
      <Phone className={icon} aria-hidden="true" />
      Callback requested
    </span>
  )
}
